import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import { chargePointActions } from "../store/actions/chargePoint.actions";
import { buttonElementModel } from "../models/common/buttonElement.model";
import ButtonElementComponent from "../components/common/ButtonElementComponent";
import validationHelper from "../utils/helpers/validation.helper";
import LoaderComponent from "../components/LoaderComponent";

/**
 * CreditGuard error return.
 *
 * The wording is deliberately generic: the browser return carries an errorCode that has no documented
 * meaning, and the clearing provider gives no dictionary for it. We never create a payment token here.
 */
export const SetPaymentDetailsErrorPageComponent = ({ chargePointActions }) => {
  const navigate = useNavigate();
  const { companyId, chargePointId, clientId } = useParams();
  const [contactMessage, setContactMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadSupportDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chargePointId]);

  const loadSupportDetails = async () => {
    setIsLoading(true);
    try {
      const response = await chargePointActions.getChargePointDetails(chargePointId);
      if (validationHelper.validateHttpResponse(response) && response.payload) {
        setContactMessage(buildContactMessage(response.payload.company));
      }
    } finally {
      setIsLoading(false);
    }
  };

  const buildContactMessage = (company) => {
    if (!company) return "";
    const { contactPhone, notificationEmail } = company;
    let message = "לפרטים נוספים, ניתן ליצור קשר עם התמיכה באחת מהדרכים:";
    message += contactPhone ? `\n במספר: ${contactPhone}` : "";
    message += notificationEmail ? `\n באימייל: ${notificationEmail}` : "";
    return contactPhone || notificationEmail ? message : "";
  };

  const handleBackToPaymentStep = () => {
    navigate(`/company/${companyId}/chargePoint/${chargePointId}?clientId=${clientId}`);
  };

  const getBackButtonElement = () => {
    const buttonElementProps = {
      ...buttonElementModel,
      label: "חזרה לבחירת אמצעי תשלום",
      onClick: handleBackToPaymentStep,
    };

    return <ButtonElementComponent buttonElementProps={buttonElementProps} />;
  };

  if (isLoading) return <LoaderComponent />;

  return (
    <div className="flexColumn gap10" dir="rtl">
      <h2>שגיאה בשמירת אמצעי התשלום</h2>
      <span>אנא נסה להזין שנית את פרטי האשראי</span>
      {contactMessage && <span style={{ whiteSpace: "pre-line" }}>{contactMessage}</span>}
      {getBackButtonElement()}
    </div>
  );
};

const mapStateToProps = (state) => ({
  chargePointReducer: state.chargePointReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    chargePointActions: bindActionCreators(chargePointActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SetPaymentDetailsErrorPageComponent);
